<template>
  <v-col cols="12">
    <v-card class="text-center pa-md-4 mx-lg">
      <core-form ref="form" :submit="submit">
        <v-card-title class="pb-0">Selecione o tipo de veículo</v-card-title>
        <input-radiogroup class="px-4" v-model="vehicleType" required row>
          <v-radio :value="1">
            <template slot="label">
              <span class="mr-2">Carro</span>
            </template>
          </v-radio>
          <v-radio :value="2">
            <template slot="label">
              <span class="mr-2">Moto</span>
            </template>
          </v-radio>
          <v-radio :value="3">
            <template slot="label">
              <span>Caminhão</span>
            </template>
          </v-radio>
        </input-radiogroup>
        <div class="col-md-12">
          <div class="mx-auto">
            <VueFileAgent
              ref="vueFileAgent"
              :multiple="false"
              :meta="true"
              :compact="compact"
              :deletable="deletable"
              :linkable="linkable"
              :editable="editable"
              :accept="valAccept"
              :theme="theme"
              @select="filesSelected($event)"
              @beforedelete="removeAll()"
              @delete="removeAll()"
              v-model="fileRecords"
              :helpText="'Escolha o arquivo para importação'"
              :errorText="{
                type: 'Tipo de arquivo inválido.',
                size: 'Tamanho do arquivo excedeu o permitido. ',
              }"
            />
          </div>
        </div>
        <div class="row" style="padding-top: 10px">
          <div class="mx-auto">
            <v-btn
              class="btn btn-outline-secondary btn-lg mr-4"
              :disabled="!fileRecords"
              type="submit"
            >
              Importar
            </v-btn>
            <v-btn
              class="btn btn-outline-secondary btn-lg"
              @click="removeAll()"
              :disabled="!fileRecords"
              >Remover Arquivo</v-btn
            >
          </div>
        </div>
      </core-form>
      <v-row>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn @click="getListStatusProcessamento" class="mt-5 float-left" v-on="on"><v-icon large>mdi-cached</v-icon></v-btn>
          </template>
          <span>Recarregar</span>
        </v-tooltip>
      </v-row>
      <v-simple-table class="mt-3">
        <thead>
          <tr class="grey lighten-3">
            <th class="text-left">Nome do Arquivo</th>
            <th class="text-left">Tipo de Veículo</th>
            <th class="text-left">Horário de Envio</th>
            <th class="text-left">Horário de Finalização</th>
            <th class="text-left">Status de Processamento</th>
            <th class="text-left">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text-left" v-for="(item, key) in listStatusImportacao" :key="key">
            <td>{{ item.nomeArquivo }}</td>
            <td>{{ $api.Kraken.tipoVeiculo(item.tipoVeiculo) }}</td>
            <td>{{ $api.UI.Format.DateTime(item.dataEnvio) }}</td>
            <td>{{ !item.dataFinalizacao || item.dataFinalizacao.indexOf("0001") != -1 ? "Em andamento" : $api.UI.Format.DateTime(item.dataFinalizacao) }}</td>
            <td>{{ item.statusProcessamento }}</td>
            <td>
              <v-icon v-if="!item.dataFinalizacao || item.dataFinalizacao.indexOf('0001') != -1" color="warning" class="">mdi-arrow-up-bold-circle</v-icon>
              <v-icon v-else-if="!item.erro" color="green">mdi-check-circle</v-icon>
              <v-tooltip v-else top>
                <template v-slot:activator="{ on }">
                  <button @click="openDetalhesErro(item.erro)" v-on="on"><v-icon color="red">mdi-message-alert</v-icon></button>
                </template>
                <span>Visualizar Detalhes</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>
    <modal-form v-model="show" :showSubmit="false" textClose="Fechar" size="lg">
      <template v-slot:title>
        Erro - Detalhes
      </template>
      <template v-slot:body>
        <v-row style="height:300px">
          <v-col md="12">
            {{ detalhesErro }}
          </v-col>
        </v-row>
      </template>
    </modal-form>
  </v-col>
</template>

<script>
export default {
  data () {
    return {
      fileRecords: null,
      vehicleType: null,
      meta: true,
      deletable: true,
      editable: true,
      linkable: true,
      sortable: true,
      disabled: false,
      compact: true,
      theme: 'list',
      valAccept: '.xls',
      listStatusImportacao: null,
      detalhesErro: null,
      show: false
    };
  },
  methods: {
    submit () {
      const th = this;
      const formData = new FormData();
      formData.append('TipoVeiculo', th.vehicleType);
      formData.append('Excel', th.fileRecords.file);
      formData.append('EmailDestino', th.$user.email);
      th.$api.Kraken.EnviarArquivoExcelFipe(formData).then(function (
        response
      ) {
        if (th.$api.UI.PostLoadData(response)) {
          th.$api.UI.Mensagem('sucesso', 'Arquivo enviado com sucesso! Acompanhe os detalhes da importação através da tabela abaixo', null, 'Aviso')
          th.fileRecords = null;
          th.$refs.form.reset();
          th.$nextTick(() => th.$set(th, 'vehicleType', null));
        }
      })
    },
    filesSelected: function (filesData) {
      var hasError = false
      var th = this
      for (var i = 0; i < filesData.length; i++) {
        if (!filesData[i].error) {
          th.fileRecords = filesData[i]
        } else {
          hasError = true
        }
      }
      if (hasError) {
        setTimeout(function () {
          th.$api.UI.ShowError('Atenção', 'Arquivo inválido...');
          th.removeAll();
        }, 700)
      }
    },
    removeAll: function () {
      this.fileRecords = null;
    },
    getListStatusProcessamento: function () {
      var th = this
      th.$api.Kraken.GetStatusProcessamentoArquivoExcelRecentes().then(response => {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.listStatusImportacao = response
        }
      })
    },
    openDetalhesErro (erro) {
      this.detalhesErro = erro
      this.show = true
    },
  },
  beforeMount () {
    this.getListStatusProcessamento()
    setInterval(
      () => { this.getListStatusProcessamento() }, 10000
    )
  }
};
</script>
